export default "__VITE_ASSET__B2I0yB9q__"